import DataResume from "@/services/DataResume";
import { Resume } from "@/types";
// import UserLogin from "@/utility/User";

import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import store from "@/store";
import { appModule } from "./app";
// import { userModule } from "./user";

export interface ResumeState {
  resume: Resume[];
}

export interface Discharge {
  id: number;
  label: string;
  value: string;
  nama: string;
}

@Module({ store, dynamic: true, namespaced: true, name: "storeResume" })
class ResumeStore extends VuexModule implements ResumeState {
  resume: Resume[] = [];
  listDischarge: Discharge[] = [];
  loading = false;

  @Mutation SET_RESUME(resume: Resume[]) {
    this.resume = resume;
  }

  @Mutation SET_LIST_DISCHARGE(list: Discharge[]) {
    this.listDischarge = list;
  }

  @Mutation
  SET_LOADING(val: boolean) {
    this.loading = val;
  }

  @Action act_resume_on_reg(param: any) {
    this.SET_LOADING(true);

    const reg = param["reg"];
    const idUser = "";
    const dt = DataResume.getDataResume(reg, idUser);
    dt.then(dt => {
      const resume = dt.data;

      this.SET_RESUME(resume);
    }).finally(() => {
      this.SET_LOADING(false);
    });
  }

  @Action act_on_discharge(term: string) {
    appModule.setLoading(true);

    const dt = DataResume.getDataDischarge(term);
    dt.then(dt => {
      appModule.setLoading(false);
      const ls = dt;
      // console.log('d', ls)
      this.SET_LIST_DISCHARGE(ls);
    });
  }
  @Action clearResume() {
      this.SET_RESUME([]);
  }
}

export const storeResume = getModule(ResumeStore);
